module.exports = __webpack_public_path__ + "img/kids-1.7089b77a.jpg";